export enum CreateAccountFields {
  first_name = 'first_name',
  last_name = 'last_name',
  password = 'password',
  email = 'email',
}

export type CreateAccountSchema = {
  [CreateAccountFields.first_name]: string;
  [CreateAccountFields.last_name]: string;
  [CreateAccountFields.password]: string;
  [CreateAccountFields.email]: string;
}
